module.exports = { id: "frame-laag", url: "/build/app/img/symbols.svg#frame-laag", viewBox: "", toString: function() { return this.url; } };